import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=c1b772f0"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=c1b772f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Privacy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports